<template>
	<div class="experience-travel">
		<Grid full-width>
			<Column no-margin>
				<h2 class="experience-travel__title" v-html="packageData.package.name"></h2>

				<h3>Type</h3>

				<p class="experience-travel__detail">{{ packageData.packageOption.title }}</p>

				<h3>Selected</h3>
			</Column>

			<Column :s="6" no-margin>
				<p class="experience-travel__detail">
					<IconPersons />
					{{ packageData.package.occupation }}
					{{ $tc('page.shop.experience_builder.travel.persons', packageData.package.occupation) }}
				</p>

				<p class="experience-travel__detail">
					<IconEnter />
					{{ packageData.package.startOfStayDate }}
				</p>
			</Column>

			<Column :s="6" no-margin>
				<p class="experience-travel__detail">
					<IconMoon />
					{{ packageData.package.nightsOfStay }}
					{{ $tc('page.shop.experience_builder.travel.nights', packageData.package.nightsOfStay) }}
				</p>

				<p class="experience-travel__detail">
					<IconLeave />
					{{ packageData.package.endOfStayDate }}
				</p>
			</Column>

			<Column class="experience-travel__detail" no-margin v-if="packageData.extras.length">
				<h3>Extras</h3>

				<p v-for="(extra, index) in packageData.extras" :key="`extra${index}`">
					{{ extra.amount }} x {{ extra.extra.name }}
				</p>
			</Column>
		</Grid>

		<div>
			<div class="experience-travel__button-container" v-if="!isShopUpdatePending">
				<Button class="experience-travel__button button--small" v-if="false" :to="travelDetailRoute">
					{{ buttonLabel }}
				</Button>

				<Button class="experience-travel__button button--small" @click.native="removeTravel(packageData)">
					{{ $t('page.shop.experience_builder.travel.remove') }}
				</Button>
			</div>

			<div v-else>
				<Spinner />
			</div>
		</div>
	</div>
</template>

<script>
import RemoveTravelMixin from '@/mixins/RemoveTravelMixin';

export default {
	name: 'ExperienceContentTravel',

	mixins: [RemoveTravelMixin],

	props: {
		products: Array,
		route: String,
		buttonLabel: String
	},

	computed: {
		packageData() {
			return this.products[0];
		},

		travelPackages() {
			return this.$store.getters['travelapi/getPackages'];
		},

		travelDetailRoute() {
			const detail = this.$store.getters['travelapi/getPackages'].find(
				pack => pack.id === this.packageData.package.id
			).slug;

			return `${this.route}/${detail}`;
		},

		isShopUpdatePending() {
			return this.$store.getters['shopapi/getIsShopUpdatePending'];
		}
	}
};
</script>

<style lang="scss">
$component: 'experience-travel';

.#{$component} {
	padding: $global-spacing;

	&__title {
		margin-bottom: $global-spacing;
	}

	&__button-container {
		display: flex;
		// justify-content: space-around;
	}

	h3 {
		opacity: 0.8;

		margin-bottom: calc($global-spacing / 2);

		font-size: 16px;
		text-transform: uppercase;
	}

	p {
		font-size: 14px;
	}

	&__detail {
		margin-bottom: $global-spacing * 0.75;

		&:last-of-type {
			margin-bottom: $global-spacing;
		}

		svg {
			margin-right: 4px;
		}
	}

	&__button {
		max-width: 200px;
	}
}
</style>
